// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3K0IkeY1mv81D5HkJRarhe","wrapperWithHeader":"_2M52cSECJsTkSc8S43_LA2","wrapperWithSidebar":"_1Jo0nWtuDm2-GWEjCEP-cF","pageTitle":"_10KGdjWwQC-9zev9-cP-Ak"};